import React from 'react';
import styled from 'styled-components';
export const ApproveDenialText = (props) => {
    const { isApprove } = props;
    if (isApprove) {
        return React.createElement(SText, null, "\u627F\u8A8D\u6E08");
    }
    else {
        return React.createElement(SText, null, "\u5426\u8A8D\u6E08");
    }
};
const SText = styled.p `
  font-weight: bold;
  font-size: 14px;
  margin: 0;
`;
